import $ from 'jquery'

import { HistoryUpdate } from 'api/history'
import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import PoziFeedback from 'drawer/tabs/info/feedback'
import { resetCurrentTarget } from 'map/actions'
import PoziMap from 'map/map'
import { targetUnset } from 'utils/target'

import PoziEdit from './edit'

/**
 * Pozi MDL Drawer Adapter for info tab
 */
export default function PoziDrawerTabInfo () {
  // Adapters
  const adapters = {
    init: function () {
      return init()
    },
    clearState: function () {
      return clearState()
    },
    hide: function () {
      return hide()
    },
    loadingMode: function () {
      return loadingMode()
    },
    loadingModeEnd: function () {
      return loadingModeEnd()
    },
    tabsMode: function () {
      return tabsMode()
    },
    tempMode: function () {
      return tempMode()
    },
    displayDataMode: function () {
      return displayDataMode()
    }
  }

  const app = PoziUtils.getApp()

  /**
   * Init
   */
  const init = function () {
    const html = Model.get('config.layout.drawer.tabs.info.html', '')
    if (html !== '') {
      $('#pozi-drawer-tabs-panel-info-nothing-selected').html(html)
    }

    $('.pozi-drawer-tabs-info').on('click', function (evt) {
      Model.set('app.drawer.activetabid', 'info')
    })

    Model.on('app.drawer.activetabid', function PoziDrawerTabInfoOnAppDrawerActiveTabID (value) {
      if (value === 'info') {
        // console.log('activetabid changed to info: Update info')
      }
    })

    PoziEdit().init()
  }

  // Clean the URL from all click actions
  const clearState = function () {
    console.log('Clear the info state (click, target, feature)')

    // Hide the location select marker
    PoziMap().removeMarker()

    Model.unset('app.state.target') // Clear any old targets.
    Model.unset('app.state.click') // Clear any old targets.
    Model.unset('app.state.clickx') // Clear any old targets.
    Model.unset('app.state.clicky') // Clear any old targets.
    Model.unset('app.state.feature') // Clear any old targets.

    // Remove any layers like 'Nearby ...'
    PoziUtils.clearLayersTurnedOnWhileOnInfoPanel()

    targetUnset()
    window.store.dispatch(resetCurrentTarget())
  }

  const hide = function () {
    console.log('Closing info panel...')

    console.log('Clear the URL from all click actions')
    clearState()
    HistoryUpdate()

    // Need to close the videos from the open cards
    $('#ytplayer').remove()

    // A bit of cleaning up
    // Clearing highlighted/selected feature and routing overlay
    // app.unselectVectorFeature()
    // app.featureOverlayUnhighlight()
    app.poziMap.removeAllOverlayFeatures()
    // app.hideRoute()

    // Activating a dummy mode to hide all lists
    app.activateMode('DUMMY')

    // console.log('If a list is open then close it to trigger the behaviour such as closing linked layers.')
    // $('.panel-heading-selected a').trigger('click')

    // Clear any google form iframe to avoid popup message.
    PoziFeedback().removeGoogleForm()

    return false
  }

  const loadingMode = function () {
    $('#pozi-drawer-tabs-panel-info-loading').show()
    $('#pozi-drawer-tabs-panel-info-nothing-selected').hide()
    $('#pozi-drawer-tabs-panel-info-react').hide()
  }

  const loadingModeEnd = function () {
    $('#pozi-drawer-tabs-panel-info-loading').hide()
    $('#pozi-drawer-tabs-panel-info-nothing-selected').show()
    $('#pozi-drawer-tabs-panel-info-react').show()
  }

  const tempMode = function () {
    $('#elt-tabs-mode').hide()
    $('#pozi-drawer-tabs-panel-info-loading').hide()
    $('#pozi-drawer-tabs-panel-info-react').hide()
    $('#pozi-drawer-tabs-panel-info-nothing-selected').hide()
    $('#pozi-drawer-tabs-panel-info-temp').show()
  }

  const tabsMode = function () {
    $('#pozi-drawer-tabs-panel-info-loading').hide()
    $('#pozi-drawer-tabs-panel-info-temp').hide()
    $('#elt-tabs-mode').show()
    $('#elt-tabs').show()
    $('#pozi-drawer-tabs-panel-info-react').show()
    $('#pozi-drawer-tabs-panel-info-nothing-selected').show()
  }

  const displayDataMode = function () {
    $('#pozi-drawer-tabs-panel-info-loading').hide()
    $('#pozi-drawer-tabs-panel-info-temp').hide()
    $('#elt-tabs-mode').show()
    $('#elt-tabs').show()
    $('#pozi-drawer-tabs-panel-info-react').show()
    $('#pozi-drawer-tabs-panel-info-nothing-selected').hide()
  }

  // Return adapters (must be at end of adapter)
  return adapters
}
